<script lang="ts">
import { page } from "$app/state";
import { chromeOf } from "$lib/i18n/copy/chrome";
import { splitLocale } from "$lib/i18n/locales";
import { countryLinks, countryLinkText } from "./country-links";

// The country pages of the page's language, each named in that language.
// `listClass` and `linkClass` let the footer and a page body style the same
// list their own way.
let { listClass = "", linkClass = "" }: { listClass?: string; linkClass?: string } = $props();

const pattern = $derived(chromeOf(page.data).footer.countryPage);
const links = $derived(countryLinks(splitLocale(page.url.pathname).locale));
</script>

<ul class={listClass}>
  {#each links as link (link.slug)}
    <li><a href={link.href} class={linkClass}>{countryLinkText(pattern, link.name)}</a></li>
  {/each}
</ul>
